import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-info-banner", () => {
    it("should have the correct classes", async () => {
        const page = await newE2EPage();
        await page.setContent(template());
        const el = await page.find("ux-info-banner");
        expect(el).toHaveClass("ux-info-banner--type-info");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(template());
        const el = await page.find("ux-info-banner");
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(template());
    });
});

function template() {
    return `
    <ux-info-banner icon="circle-info" type="info">
        <p>
            Updates on the platform: Lorem ipsum kmflkw gkejgoerno
            gkernoger goerngoe ognreo gone genjng
        </p>
    </ux-info-banner>
    `;
}
